const LEADING_INVISIBLE_CHARACTERS = '[\\s\\p{Cf}\\p{Cc}]*';

const FORMULA_TRIGGER_PATTERN = new RegExp(`^${LEADING_INVISIBLE_CHARACTERS}[=+\\-@]`, 'u');

const PHONE_OR_DECIMAL_PATTERN = new RegExp(`^${LEADING_INVISIBLE_CHARACTERS}[+-]?[\\d\\s().,-]+$`, 'u');

const CONTAINS_A_DIGIT_PATTERN = /\d/;

/**
 * A value built only from digits and numeric punctuation cannot name a function, reference another
 * cell or open a DDE channel, so a leading + or - on one is arithmetic at worst and the marker would
 * only put an apostrophe in front of every phone number in the export.
 */
const isPhoneOrDecimalValue = (value: string): boolean => {
  return PHONE_OR_DECIMAL_PATTERN.test(value) && CONTAINS_A_DIGIT_PATTERN.test(value);
};

/**
 * Excel, Sheets and LibreOffice decide a cell is a formula from its first character, whether or not
 * the cell was quoted in the file. An apostrophe is how those applications are told it is text.
 */
export const withFormulaTextMarker = (value: string): string => {
  return FORMULA_TRIGGER_PATTERN.test(value) && !isPhoneOrDecimalValue(value) ? `'${value}` : value;
};

export const quoteCsvCell = (value: string): string => {
  return `"${value.replace(/"/g, '""')}"`;
};

export const toCsvCell = (value: string): string => {
  return quoteCsvCell(withFormulaTextMarker(value));
};

export const toCsvRow = (values: readonly string[]): string => {
  return values.map((value: string): string => toCsvCell(value)).join(',');
};

export const toCsvText = (headerCells: readonly string[], dataRows: readonly string[]): string => {
  return [toCsvRow(headerCells), dataRows.join('\n')].join('\n');
};
